import "./style.scss";

import { InputAdornment } from "@mui/material";
import DateFormComponent from "components/shared/FormComponent/DateFormComponent";
import TextFormComponent from "components/shared/FormComponent/TextFormComponent";
import StyledTextField from "components/shared/StyledTextField/StyledTextField";
import type { TControlNameSpecificChannels } from "components/TitleFormContainer/types";
import { useTranslation } from "react-i18next";

import { FlagTag } from "..";

interface IChannelContent {
    /**
     * Index of the channel
     */
    index: number;
    /**
     * React useFormContext() hooks
     */
    useFormContextData: any;
    /**
     * Name of the specific channel to control with useForm()
     */
    controlName: TControlNameSpecificChannels;
    showName?: boolean;
    showEan13?: boolean;
    showReleaseDate?: boolean;
}

const ChannelContent = ({
    index,
    useFormContextData,
    controlName,
    showName = false,
    showEan13 = false,
    showReleaseDate = false,
}: IChannelContent) => {
    const [t] = useTranslation();
    const { control, errors } = useFormContextData;

    if (!showName && !showEan13 && !showReleaseDate) {
        return null;
    }

    return (
        <div className="specific-channel-content flex gap-3">
            {showName && (
                <TextFormComponent
                    className="min-w-2/5"
                    control={control}
                    label={t("NewTitle.Title")}
                    controlName={controlName.name}
                    size="small"
                />
            )}

            {showEan13 && (
                <TextFormComponent
                    className="w-2/5"
                    control={control}
                    label={t("NewTitle.ISBN")}
                    controlName={controlName.ean13}
                    size="small"
                    error={errors.overriddenChannelsData && errors.overriddenChannelsData[index]?.ean13}
                    required
                />
            )}

            {showReleaseDate && (
                <div className="w-1/5 min-w-30">
                    <DateFormComponent
                        control={control}
                        label={t("NewTitle.ReleaseDate")}
                        controlName={controlName.releaseDate}
                        size="small"
                        maxYearDistance={10}
                    />
                </div>
            )}
        </div>
    );
};

export default ChannelContent;

interface ISmallCurrenctInput {
    option: any;
    flag: string;
}

export const SmallCurrencyInput = ({ option, flag }: ISmallCurrenctInput) => {
    const [t] = useTranslation();
    return (
        <StyledTextField
            {...option}
            placeholder={t("NewTitle.SelectCurrency")}
            size="small"
            className="title-specific-channels-currency-input"
            InputProps={{
                ...option.InputProps,
                startAdornment: (
                    <InputAdornment position="end">
                        <FlagTag
                            flagUrl={flag}
                            flagStyle={{
                                width: "12px",
                                height: "12px",
                                opacity: "0.8",
                                marginLeft: "0.25rem",
                                display: "flex",
                                alignItems: "center",
                            }}
                        />
                    </InputAdornment>
                ),
            }}
        />
    );
};

interface ISmallOptionCurrenciesInput {
    props: any;
    option: any;
    currencyCodeOption: string;
}
export const SmallOptionCurrenciesInput = ({ props, option, currencyCodeOption }: ISmallOptionCurrenciesInput) => {
    return (
        <li {...props} key={option.code} className="currencies-title-options-list">
            <img src={option.flag} style={{ width: "15px", height: "15px" }} />
            <div className="currencies-info">
                <span className="currency-name" style={{ fontSize: "11px" }}>
                    {option.name}
                </span>
                <span className="currency-code" style={{ fontSize: "11px" }}>
                    {currencyCodeOption}
                </span>
            </div>
        </li>
    );
};
